<template>
  <div class="content-page mobile-app">
    <div class="main-page">
      <div class="title-page">行政复议网上申请平台</div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <van-notice-bar
            wrapable
            v-if="isHint"
            left-icon="info-o"
            :scrollable="false"
            text="为做好新《中华人民共和国行政复议法》的实施准备工作，“上海市行政复议网上申请平台”、“上海复议”小程序以及随申办“上海复议”模块将于2023年12月29日 17:30--2023年12月31日24：00进行系统升级改造，期间网上申请平台、“上海复议”小程序和随申办“上海复议”模块将关闭入口。系统改造期间如需申请行政复议，可通过邮寄方式向各级行政复议机关提交申请。"
          />
          <!-- 版本更新提示 -->
          <div v-if="showVersionUpdateTip && versionUpdateTipText" class="version-update-tip">
            <img class="version-img" src="~@/assets/images/notice-icon.png" alt=""/>
            <div class="version-text">{{ versionUpdateTipText }}</div>
          </div>
          <div class="co-contentBox">
            <div class="co-rightBox">
              <div class="star-title">
                <span class="star"></span>网上申请内容介绍<span v-if="$route.query.state">.</span>
              </div>
              <div class="co-rightText">
                “行政复议网上申请”是为方便公民、法人和其他组织（以下统称申请人）行使复议申请权，开辟的行政复议申请渠道。申请人可通过本网站提交行政复议申请及相关材料。经初步审查后，如申请材料齐全、真实，行政复议机构将根据行政复议法的相关规定依法作出处理。 </div>
              <!-- 登录状态显示 -->
              <div class="login-section">
                <div v-if="isLogin" class="user-info">
                  <div class="user-name">
                    <span>您好，{{ userName }}</span>
                    <img class="true_name_icon" src="~@/assets/images/true_name_icon.png" alt="" @click="logout"/>
                  </div>
                  <div class="logout_btn" @click="logout">退出</div>
                </div>
                <div v-else class="user-info">
                  <div class="user-name"></div>
                  <div class="login_btn" @click="goToLogin">登录</div>
                </div>
              </div>
              
              <div class="btnList">

                <div class="btn-item" type="primary" @click="go('apply','/m-matterTip')">
                  <img src="~@/assets/images/mobile/apply.png" alt="" srcset=""/>
                  <span>我要申请</span>
                </div>
                <div class="btn-item" type="primary" @click="go('revokeApply','/m-selectType')">
                  <img src="~@/assets/images/mobile/revo.png" alt="" srcset=""/><span>我要撤回</span>
                </div>
                <div class="btn-item" type="primary" @click="go('search','/m-selectType')">
                  <img src="~@/assets/images/mobile/search.png" alt="" srcset=""/><span>我的案件</span>
                </div>
              </div>
            </div>
            <!--            <div class="co-leftBox">-->
            <!--              <div class="star-title">-->
            <!--                <span class="star"></span>网上申请查询-->
            <!--              </div>-->
            <!--              <el-form :model="searchForm" :rules="rules" ref="searchForm" label-width="120px"-->
            <!--                       class="demo-ruleForm search-items ">-->
            <!--                <el-form-item label="申请编号" prop="number" class=" col1-80">-->
            <!--                  <el-input placeholder="请输入申请编号" v-model.trim="searchForm.number" maxlength="20"></el-input>-->
            <!--                </el-form-item>-->
            <!--                <el-form-item label="密码" prop="password" class=" col1-80">-->
            <!--                  <el-input type="password" placeholder="请输入密码" v-model.trim="searchForm.password"-->
            <!--                            autocomplete="new-password" maxlength="10"></el-input>-->
            <!--                </el-form-item>-->
            <!--              </el-form>-->
            <!--              <div class="btnLists">-->
            <!--                <div v-no-more-div class="primary-btn" @click="submitForm('searchForm')"> 查询 </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- 注册异常弹窗 -->
    <van-dialog
      v-model="showRegestStatusDialog"
      title=""
      :close-on-click-overlay="false"
      :close-on-popstate="true"
      :show-confirm-button="false"
    >
      <div class="regest-status-content">
        <div class="regest-status-close" @click="closeRegestStatusDialog">
          <i class="el-icon-close"></i>
        </div>
        <div class="regest-status-text" v-html="regestStatusTips"></div>
        <div class="regest-status-contact" v-if="regestStatusPhone || regestStatusTime">
          <div class="contact-item" v-if="regestStatusPhone">{{ regestStatusPhone }}</div>
          <div class="contact-item" v-if="regestStatusTime">{{ regestStatusTime }}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Api from '@api/api'
import { uuid } from '@/utils'
import { decryptSsbUserInfo } from '@/utils/cryptp.js'
export default {
  data () {
    return {
      isHint: window.g.hint,
      isLogin: false, // 是否已登录
      userName: '', // 用户名
      searchForm: {
        number: null,
        password: null
      },
      state: uuid(), // 生成授权state参数
      rules: {
        number: [
          { required: true, message: '请输入申请编号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      // 注册异常弹窗相关
      showRegestStatusDialog: false,
      regestStatusTips: '',
      regestStatusPhone: '',
      regestStatusTime: '',
      // 版本更新提示相关
      showVersionUpdateTip: false,
      versionUpdateTipText: ''
    }
  },
  mounted(){
    // 检查登录状态
    this.checkLoginStatus()

    // 判断配置文件下 是否开启隋申班app授权参数
    if(window.g.isOpenAuth){

      this.authorize()
      // this.accessToken('1DWv0jzAppp6Db4624')
    }
    
    // 检查是否需要显示注册状态弹窗
    if (this.$route.query.showRegestStatusDialog === 'true') {
      this.getRegestStatusDialogContent()
    }
    
    // 获取版本更新提示
    this.getVersionUpdateTip()
  },
  activated () {
    // 每次激活时检查登录状态
    this.checkLoginStatus()
  },
  methods: {
    // 授权接口
    authorize(){
      // 随申办 APP 回跳时 code/access_token 可能拼在 hash(#) 之前，落到 window.location.search 里，
      // 此时 this.$route.query 读不到，需从 location.search 兜底解析（小程序走 hash 后 query，APP 走 search）
      const searchParams = new URLSearchParams(window.location.search)
      let code = this.$route.query.code || searchParams.get('code')
      let access_token = this.$route.query.access_token || searchParams.get('access_token')
      localStorage.setItem('state', this.$route.query.state || searchParams.get('state') || '')

      console.log('链接的toekn',access_token);
      if (access_token) {
        // 获取其他授权用户信息
        console.log('链接token直接获取用户信息');
        this.getUser(access_token)
      } else {
        if(localStorage.getItem('userInfo')){
          return;
        }
        // 无code
        if(!code ){
          this.requestAuthorize()
        } else {
          // code 是一次性凭证：从 login 页右滑返回本页时，URL 里仍挂着旧 code，
          // 若再次 accessToken(code) 会被网关判为「code 已失效」。此处对已消费的 code
          // 不再重复换取，而是重新发起一轮授权以获取新的 code 后重试。
          if (sessionStorage.getItem('usedOauthCode') === code) {
            console.warn('该 code 已使用过，重新发起授权获取新 code:', code)
            this.requestAuthorize()
            return
          }
          sessionStorage.setItem('usedOauthCode', code)
          console.log(code);
          // 有code，去调取token
          this.accessToken(code)
        }
      }
    },

    // 发起授权重定向：获取一个新的 code
    requestAuthorize(){
      Api.authorize({
        state: this.state
      }).then(({ data }) => {
        if(data.code == 0){
          console.log(data.data);
          location.href = data.data
        } else {
          if (data.msg && !['系统异常', '后台服务异常'].includes(data.msg)) {
            this.$toast(data.msg)
          } else {
            console.error('Error:', data.msg)
          }
        }
      })
    },

    // 小程序 授权或者用户信息
    getUser(access_token){
      console.log('用户接口');
      Api.getUser({
        access_token
      }).then(({ data }) => {
        if(data.code == 0 && data.data.zwdtsw_user_type){
          console.log('成功',data.data);
          let obj = {}
          if(data.data.zwdtsw_user_type == '个人'){
            obj.idcard = data.data.zwdtsw_cert_id
            obj.name = data.data.zwdtsw_name
            obj.userName = data.data.zwdtsw_account
            obj.mobile = data.data.zwdtsw_link_phone
            obj.status = data.data.usergrade
            obj.userId = data.data.zwdtsw_user_id
          } else {
            obj.name = data.data.zwdtsw_link_person
            obj.qyname = data.data.zwdtsw_law_person
            obj.mobile = data.data.zwdtsw_link_phone
            obj.userId = data.data.zwdtsw_user_id
          }
          localStorage.setItem('userInfo',JSON.stringify(obj))
          console.log('✅ 小程序 userInfo 已存入 localStorage:', obj)

        } else {
          console.log('失败==',data.msg);
          // this.$toast(data.msg)
        }
      })
    },

    // 获取token
    accessToken(code){
      Api.accessToken({
        code: code
      }).then(({ data }) => {
        if(data.code == 0){
          console.log(data.data);
          let RESdata = data.data ? JSON.parse(data.data) : {}
          localStorage.setItem('accessToken', RESdata.access_token)
          localStorage.setItem('username', RESdata.username)
          this.getUserInfo()
        } else {
          console.error('accessToken error:', data.msg)
        }
      })
    },

    getUserInfo(){
      // 多节点部署 session 不共享，token 从 localStorage 透传给后端
      Api.getUserInfo({
        access_token: localStorage.getItem('accessToken'),
        username: localStorage.getItem('username')
      }).then(({ data }) => {
        if(data.code == 0){
          let resData = decryptSsbUserInfo(data.data, window.g.keyWords)

          if (!resData || resData.trim() === '') {
            console.error('解密失败：返回空字符串，请检查密钥是否正确')
            return
          }

          // 尝试解析为 JSON，验证解密是否成功
          try {
            JSON.parse(resData)
            localStorage.setItem('userInfo', resData)
          } catch (e) {
            console.error('解密结果不是有效 JSON，解密可能失败:', resData)
          }
        } else {
          console.error('getUserInfo error:', data.msg)
          if(data.msg.includes('1005')){
            this.refrcesh()
          } else if(data.msg.includes('1006')) {
            this.$router.push({ name: 'McodeSearch' })

          }
        }
      })
    },

    refrcesh(){
      // 多节点部署 session 不共享，token 从 localStorage 透传给后端
      Api.refrcesh({
        access_token: localStorage.getItem('accessToken'),
        username: localStorage.getItem('username')
      }).then(({ data }) => {
        if(data.code == 0){
          console.log(data.data);
          let RESdata = data.data ? JSON.parse(data.data) : {}
          localStorage.setItem('accessToken', RESdata.access_token)
          localStorage.setItem('username', RESdata.username)
          this.getUserInfo()
        } else {
          console.error('refrcesh error:', data.msg)
          if(data.msg.includes('1005')){
            this.refrcesh()
          } else if(data.msg.includes('1006')) {
            this.$router.push({ name: 'McodeSearch' })
          }
        }
      })
    },



    // 检查登录状态
    checkLoginStatus () {
      const isLogin = localStorage.getItem('isLogin')
      if (isLogin === 'true') {
        this.isLogin = true
        this.userName = localStorage.getItem('loginName') || ''
      } else {
        this.isLogin = false
        this.userName = ''
      }
    },
    // 跳转到登录页面（先进行人脸识别）
    goToLogin () {
      // 调试：检查跳转登录页时 userInfo 是否已存在
      const userInfo = localStorage.getItem('userInfo')
      console.log('点击登录时 localStorage.userInfo:', userInfo ? JSON.parse(userInfo) : '未找到')
      this.$router.push({ name: 'MLogin' })
    },
    // 退出登录
    logout () {
      this.$dialog.confirm({
        title: '提示',
        message: '确定要退出登录吗？'
      }).then(() => {
        // 清除登录相关数据
        localStorage.removeItem('loginName')
        localStorage.removeItem('loginIdentificationCard')
        localStorage.removeItem('token')
        localStorage.removeItem('sessionId')
        localStorage.removeItem('isRegistered')
        localStorage.removeItem('isLogin')
        localStorage.removeItem('wssqUser')
        localStorage.removeItem('phone')
        localStorage.removeItem('phoneNumber')
        localStorage.removeItem('oprate')
        localStorage.removeItem('applicantInfo')
        // 更新页面状态
        this.isLogin = false
        this.userName = ''
        this.$toast({
          message: '已退出登录',
          type: 'success'
        })
      }).catch(() => {
        // 取消操作
      })
    },
    go (oprate, url) {
      // 检查登录状态
      const isLogin = localStorage.getItem('isLogin')
      if (isLogin !== 'true') {
        this.$toast({
          message: '请先登录',
          type: 'fail'
        })
        return
      }
      localStorage.setItem('oprate', oprate)
      this.$router.push(url)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api.detail(this.searchForm).then((res) => {
            if (res.data.code === '0') {
              this.$message({
                message: '查询成功',
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.$cookie.set('LoginPass', this.searchForm.password)
                  this.$router.push({
                    name: 'MDetailCase',
                    query: {
                      number: this.searchForm.number
                    }
                  })
                }
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取注册状态弹窗内容
    getRegestStatusDialogContent () {
      Api.getRegestStatusDialogContent().then(res => {
        let tips = '';
        if (res.data.code === '0' && res.data.data) {
          // 处理不同的数据格式
          tips = res.data.data.tips || res.data.data.content || '';
          this.regestStatusPhone = res.data.data.phone || '';
          this.regestStatusTime = res.data.data.time || '';
        }
        
        // 如果获取到内容则使用，否则使用默认内容
        if (!tips) {
          tips = '当前信息已被注册,请确认您的信息填写准确,如您需要申诉或者修改手机号请联系:\n电话: 021-12345678\n时间: 10:00~17:00';
        }
        
        // 将换行符转换为 HTML 跳行
        this.regestStatusTips = tips.replace(/\n/g, '<br/>');
        
        // 显示弹窗
        this.showRegestStatusDialog = true;
      }).catch(err => {
        console.log('getRegestStatusDialogContent error', err);
        // 接口调用失败，使用默认内容
        this.regestStatusTips = '当前信息已被注册,请确认您的信息填写准确,如您需要申诉或者修改手机号请联系:<br/>电话: 021-12345678<br/>时间: 10:00~17:00';
        this.showRegestStatusDialog = true;
      });
    },
    // 关闭注册状态弹窗
    closeRegestStatusDialog () {
      this.showRegestStatusDialog = false;
      this.regestStatusTips = '';
      this.regestStatusPhone = '';
      this.regestStatusTime = '';
      // 清除路由参数
      this.$router.replace({ name: 'MCodeSearch' });
    },
    // 获取版本更新提示
    getVersionUpdateTip () {
      Api.getVersionUpdateTip().then(res => {
        console.log('版本更新提示接口返回：', res);
        let tipText = '';
        if (res.data.code === '0' && res?.data?.data) {
          tipText = res.data.data.title || null;
        }
        
        // 如果获取到内容则显示，否则不显示提示
        if (tipText) {
          this.showVersionUpdateTip = true;
          this.versionUpdateTipText = tipText;
        } else {
          this.showVersionUpdateTip = false;
          this.versionUpdateTipText = '';
        }
      }).catch(err => {
        console.log('获取版本更新提示失败：', err);
        // 接口调用失败，不显示提示
        this.showVersionUpdateTip = false;
        this.versionUpdateTipText = '';
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.main-contentBox {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;
  background: url('~@/assets/images/contentBG.png') no-repeat;
  justify-content: center;
  background-size: 104% 104%;
  background-position: 40% -22px;
  //  padding: 140px 140px 160px;
  //  padding: 10% 10% 11%;
  .version-update-tip {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 16px;
    margin: 16px 0;
    font-weight: 700;
    
    .version-img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      flex-shrink: 0;
    }
    
    .version-text {
      flex: 1;
      color: #000;
      font-size: 14px;
      line-height: 22px;
    }
  }



  .co-contentBox {
    display: flex;
    align-items: baseline;
    justify-content: space-around;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    padding: 2% 0;

    .co-leftBox {
      margin: 0 2%;
    }

    .co-rightBox {
      width: 100%;

      .login-section {
        margin: 16px 0;
        
        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
          justify-content: space-between;
          
          .user-name {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 16px;
            color: #000;
            
            .true_name_icon {
              width: 16px;
              height: 16px;
              cursor: pointer;
            }
          }
          
          .logout_btn {
            width: 64px;
            padding: 6px 16px;
            background: #199CD5;
            border-radius: 4px;
            font-size: 14px;
            color: #fff;
            cursor: pointer;
          }
        }
        
        .login_btn {
          width: 64px;
          padding: 8px 18px;
          background: #199CD5;
          border-radius: 4px;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
      }

      .co-rightText {
        word-break: break-all;
        width: 100%;
        margin: 0 auto;
        color:#000;
        font-size: 14px;
        line-height: 22px;
      }
    }

    .btnList {
      margin: 12px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn-item {
        display: flex;
        text-align: center;
        flex-direction: column;
      }
      .el-col {
        margin-top: 20px;
      }
      img {
        width:72px;
        height:72px;
      }
      span {
        color: #000;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }


  @media screen and (max-width: 1000px) {
    .backgroundBox {
      background: none!important;
    }
    .co-contentBox {
      display: flex;
      width: 100%;
      padding: 16px;
      padding-bottom: 20px;
      backdrop-filter: none;
      flex-direction:column;
      position:relative;
      // background-color: pink;
    }
    .co-leftBox {
      //  position: absolute;
      //  top: 0;
      //  left: 0;
      width: 100% !important;

      .el-input{
        width: 140px !important;
      }
      .primary-btn{
        margin-top: -10px;
      }
    }



    .co-rightBox {
      //  margin-top: 220px !important;
      width: 100% !important;
      .border-btn{
        margin-top: 10px !important;
        margin-bottom: 20px !important;
      }
    }

    .primary-btn {
      width: 120px !important;
    }

    .gary-btn {
      width: 120px !important;
    }

    .border-btn {
      width: 120px !important;
    }

    .col1-80 {
      width: 100% !important;

    }
  }
}

// 注册异常弹窗样式
::v-deep .van-dialog {
  padding: 10px;
  width: 90% !important;
}
.regest-status-content {
  padding: 20px;
  position: relative;
  .regest-status-close {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #969799;
    font-size: 18px;
    &:hover {
      color: #323233;
    }
  }
  .regest-status-text {
    font-size: 14px;
    color: #606266;
    line-height: 1.8;
    margin-bottom: 15px;
    white-space: pre-wrap;
    padding-right: 20px;
  }
  .regest-status-contact {
    margin-top: 15px;
    .contact-item {
      font-size: 14px;
      color: #606266;
      line-height: 1.8;
      margin-bottom: 5px;
    }
  }
}
</style>
